import { FC, ReactNode } from "react";
import KickImage from 'Reuseables/KickImage';
import { Modal } from "react-bootstrap";
import styled from "styled-components";

//Constants
import { FontFamilyBold, FontFamilyRegular } from "../../constants"

// Define Interface
type Props = {
  id?: string;
  show?: boolean;
  onHide: () => void;
  children: ReactNode;
}

interface StyledCompProps {
  fontFamilyBold?: string;
  fontFamilyRegular?: string;
}

const StyledComponent = styled.div<StyledCompProps>`
  
`
StyledComponent.defaultProps = {
  fontFamilyBold: FontFamilyBold,
  fontFamilyRegular: FontFamilyRegular
}


const ModalTopLevel: FC<Props> = ({
  id,
  children,
  onHide,
  show
}) => {
  return (
    <Modal id={`top-level-modal`} fullscreen={true} onHide={onHide} centered show={show}>
      {children}
    </Modal>
  )
}
ModalTopLevel.defaultProps = {
  id: "",
  show: false,
  onHide: () => {},
  children: <div />
}

export default ModalTopLevel